export default __webpack_public_path__ + "static/media/padel-platinum-logo.0f1cdc74.png";